import { apiFetch } from "@core/index";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";

export const useDeletePartnerChannel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: { id: string }) => {
      const response = await apiFetch<{ statusCode: number; message: string }>(
        `${apiEndpoint}/${config.id}`,
        {
          method: "DELETE",
        },
      );
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message, {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Partner channel deleted successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["partnerChannels"] });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(
        "Failed to delete partner channel. Error: " + error.message,
        {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        },
      );
    },
  });
};
